import React, { useEffect, useState } from "react";
import { Grid, TextField, Button } from "@mui/material";
import axios from "axios";
import baseUrl from "../../../config/baseUrl";

function Directors() {
  const auth = sessionStorage.getItem("user");

  const [formState, setFormState] = useState({
    director1_name: "",
    director1_dob: "",
    director1_nationality: "",
    director2_name: "",
    director2_dob: "",
    director2_nationality: "",
  });

  const ReadData = async () => {
    try {
      let values = {
        tab: 3,
      };
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${auth}`,
        },
      };
      let result = await axios.post(
        `${baseUrl}/defaultBusinesSettingData`,
        values,
        config
      );
      setFormState(result.data.result);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      let values = {
        director1_name: formState.director1_name,
        director1_dob: formState.director1_dob,
        director1_nationality: formState.director1_nationality,
        director2_name: formState.director2_name,
        director2_dob: formState.director2_dob,
        director2_nationality: formState.director2_nationality,
      };

      const config = {
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${auth}`,
        },
      };

      let result = await axios.post(
        `${baseUrl}/save-director-info`,
        values,
        config
      );
      if (result.status === 200) {
        alert(result.data.message);
      } else {
        alert(result.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    ReadData();
  }, []);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Name Of The First Director"
          name="director1_name"
          value={formState.director1_name}
          variant="outlined"
          onChange={handleChange}
          helperText="Mandatory"
            InputLabelProps={{
                shrink: true
            }}
            FormHelperTextProps={{ sx: { color: 'red' } }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Date Of Birth First Director"
          type="date"
          name="director1_dob"
          value={formState.director1_dob}
          variant="outlined"
          onChange={handleChange}
          helperText="Mandatory"
            InputLabelProps={{
                shrink: true
            }}
            FormHelperTextProps={{ sx: { color: 'red' } }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Nationality of First Director"
          name="director1_nationality"
          value={formState.director1_nationality}
          variant="outlined"
          onChange={handleChange}
          helperText="Mandatory"
            InputLabelProps={{
                shrink: true
            }}
            FormHelperTextProps={{ sx: { color: 'red' } }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Name Of The Second Director"
          name="director2_name"
          value={formState.director2_name}
          variant="outlined"
          onChange={handleChange}
          helperText="Optional"
            InputLabelProps={{
                shrink: true
            }}
            FormHelperTextProps={{ sx: { color: 'orange' } }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Date Of Birth Of Second Director"
          type="date"
          name="director2_dob"
          value={formState.director2_dob}
          variant="outlined"
          onChange={handleChange}
          helperText="Optional"
            InputLabelProps={{
                shrink: true
            }}
            FormHelperTextProps={{ sx: { color: 'orange' } }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Nationality Of Second Director"
          name="director2_nationality"
          value={formState.director2_nationality}
          variant="outlined"
          onChange={handleChange}
          helperText="Optional"
            InputLabelProps={{
                shrink: true
            }}
            FormHelperTextProps={{ sx: { color: 'orange' } }}
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <Button
          onClick={handleSave}
          variant="contained"
          color="success"
          size="medium"
          sx={{
            float: "inline-end",
          }}
        >
          Save
        </Button>
      </Grid>
    </Grid>
  );
}

export default Directors;
